export default __webpack_public_path__ + "static/media/tower.1f3a7faf.png";